export const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };
  
  export const getToken = () => {
    const token = localStorage.getItem('token');
  
    return token || '';
  };
  
  
  export const deleteToken = () => {
    const token =  localStorage.removeItem('token');
   
    return token !== null;
  };
  